import { render, staticRenderFns } from "./DiscoveryBoxBudget.vue?vue&type=template&id=0829b9a9"
import script from "./DiscoveryBoxBudget.vue?vue&type=script&lang=js"
export * from "./DiscoveryBoxBudget.vue?vue&type=script&lang=js"
import style0 from "./DiscoveryBoxBudget.vue?vue&type=style&index=0&id=0829b9a9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports